import { Experience } from "@/components/Experience";
import { PageTopBanner } from "@/components/PageTopBanner";
import { CTABanner } from "@/components/CTABanner";
import { Footer } from "@/components/Footer";
import { SEO } from "@/components/SEO";
import Lottie from "lottie-react";
import binocularsAnimation from "@/assets/binoculars.json";

const CV = () => {
  return (
    <div className="min-h-screen pt-20">
      <SEO
        title="CV & Experience | Khaled Kasmou — Product & UX/UI Designer"
        description="Curriculum Vitae of Khaled Kasmou: product design, UX/UI, design systems, and design leadership experience across digital products."
        path="/cv"
        type="profile"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "Person",
          name: "Khaled Kasmou",
          url: "https://khaledkasmou.me/cv",
          jobTitle: "Product & UX/UI Designer",
          address: {
            "@type": "PostalAddress",
            addressLocality: "Sofia",
            addressCountry: "BG",
          },
          hasOccupation: {
            "@type": "Occupation",
            name: "Product & UX/UI Designer",
            occupationLocation: {
              "@type": "City",
              name: "Sofia, Bulgaria",
            },
            skills: "UX Design, UI Design, UX Research, Design Systems, AI-assisted Design, Design Leadership, Figma, Product Strategy",
          },
        }}
      />
      <main>
      <div className="relative">
        <PageTopBanner
          titleKey="cv.banner.title"
          subtitleKey="cv.banner.subtitle"
          title=""
        />
        {/* Binoculars Animation */}
        <div aria-hidden="true" className="absolute -bottom-16 left-1/2 -translate-x-1/2 w-32 h-32 md:w-40 md:h-40 animate-fade-in z-10">
          <Lottie animationData={binocularsAnimation} loop={true} />
        </div>
      </div>
      <Experience />
      <CTABanner />
      </main>
      <Footer />
    </div>
  );
};

export default CV;
